import { PostSseClient } from "../PostSseClient";
import type { PostSseClientOptions } from "../PostSseClient";

/**
 * Композиционный корень потоков событий поверх POST: единственное место, где
 * выбирается реализация. Экранные хуки просят поток здесь и получают уже
 * собранный клиент, поэтому подмена транспорта делается в одном файле.
 */
export function createPostSseClient(options: PostSseClientOptions): PostSseClient {
  return new PostSseClient(options);
}
